import * as React from 'react';
import { useEffect } from 'react';
import {
  AriaKeyClientType,
  useGetAriaKeyQuery
} from '../../../generated/graphql';
import { useTeamsContext } from '../../teams-tabs/teams-context/TeamsContext';
import { flushTelemetry, initializeTelemetryClient } from '../telemetryClient';
import { TelemetryIngestionContextProvider } from './TelemetryIngestionContextProvider';
import { ITelemetryIngestionContextProviderProps } from './TelemetryIngestionContextProvider.types';

export const ConnectedTelemetryIngestionContextProvider: React.FC<ITelemetryIngestionContextProviderProps> = props => {
  const { teamsContext } = useTeamsContext();
  const hostClientType = (teamsContext?.hostClientType ||
    AriaKeyClientType.Default) as AriaKeyClientType;
  const { data: ariaIngestionKey } = useGetAriaKeyQuery({
    variables: { clientType: hostClientType },
    skip: !teamsContext
  });

  useEffect(() => {
    initializeTelemetryClient(ariaIngestionKey?.getAriaKey);

    return () => {
      flushTelemetry();
    };
  }, [ariaIngestionKey]);

  return (
    <TelemetryIngestionContextProvider
      {...props}
      ariaIngestionKey={ariaIngestionKey?.getAriaKey}
    />
  );
};
